/* =====================================================================
   Viscosity Labs · brand-rehaul/prototype
   main.js — loaded on every page.

   Responsibilities:
     1. Reveal-on-scroll for [data-reveal] (below-the-fold content only).
     2. Nav auto-hide on scroll-down.
     3. Smooth in-page anchor scrolling, with focus moved for keyboard
        users.

   The FAQ accordion needs no JS — it uses native <details name> for
   exclusive open. Performance: transform / opacity only,
   IntersectionObserver over scroll listeners, passive listeners.
   ===================================================================== */

(() => {
  "use strict";

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1. Reveal on scroll ---------- */
  const revealEls = document.querySelectorAll("[data-reveal]");
  if (reduceMotion || !("IntersectionObserver" in window)) {
    revealEls.forEach((el) => el.classList.add("is-visible"));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.12 }
    );
    revealEls.forEach((el) => io.observe(el));
  }

  /* ---------- 2. Nav auto-hide on scroll-down ---------- */
  const nav = document.getElementById("vl-nav");
  if (nav) {
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > lastY && y > 160) {
        nav.classList.add("is-hidden");
      } else {
        nav.classList.remove("is-hidden");
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ---------- 3. Smooth in-page anchor scrolling ----------
     Only same-page hashes. Cross-page links (index.html#buy) fall
     through to normal navigation. */
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("href").slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
    });
  });
})();
